import React from 'react';
import '../UploadForm.css';

const MAX_CHARS = 3600;

function JobDescriptionInput({ keywordsLocked, value, onChange, onError, disabled = false }) {
  const handleChange = (e) => {
    if (keywordsLocked) return;
    let text = e.target.value;
    if (text.length > MAX_CHARS) {
      text = text.slice(0, MAX_CHARS);
      onError && onError('Character limit reached.');
    } else {
      onError && onError('');
    }
    onChange && onChange(text);
  };

  return (
    <div className="job-description-container">
      <label className="job-description-label">Job Description</label>
      <br />
      <textarea
        value={value}
        onChange={disabled || keywordsLocked ? undefined : handleChange}
        placeholder={
          keywordsLocked
            ? 'Keywords locked - job description ignored'
            : 'Paste the job description here..\n\nTip: We recommend pasting just the relevant "responsibilities" and "requirements" sections'
        }
        className="job-description-textarea"
        style={
          keywordsLocked
            ? { backgroundColor: '#f5f5f5', color: '#9e9e9e', cursor: 'not-allowed' }
            : {}
        }
        disabled={keywordsLocked || disabled}
        aria-disabled={keywordsLocked || disabled}
        aria-busy={disabled || undefined}
      />
      <div className="word-count">{MAX_CHARS - value.length} / {MAX_CHARS}</div>
    </div>
  );
}

export default JobDescriptionInput;


